/**
 * Nomenclatura oficial Certifirma / marca Certicámara (copy visible al usuario).
 * IDs técnicos internos (p. ej. SignMechanism) pueden diferir; usar estas etiquetas en UI.
 */

export const BRAND = {
  PRODUCT_NAME: 'CertiTool',
  PRODUCT_NAME_WEB: 'CertiTool Web',
  /** Endoso de marca (manual: by certicámara.) */
  ENDORSEMENT: 'by certicámara.',
  LEGAL_NAME: 'Certicámara S.A.',
  WORDMARK: 'certicámara.'
} as const;

/** Soluciones de firma — nombres oficiales del portafolio */
export const CERTIFIRMA = {
  VIRTUAL: 'Certifirma Digital Virtual',
  VIRTUAL_SHORT: 'Certifirma Virtual',
  VIRTUAL_OTP: 'Certifirma Digital Virtual con OTP',
  PKCS10: 'Certifirma Digital PKCS10',
  FISICO: 'Certifirma Digital Físico',
  FISICO_SHORT: 'Certifirma Físico',
  WEB: 'Certifirma Web'
} as const;

/** Rutas canónicas de administración (URLs públicas) */
export const ADMIN_ROUTES = {
  VIRTUAL: '/administrar/certifirma-virtual',
  VIRTUAL_OTP: '/administrar/certifirma-virtual-otp',
  PKCS10: '/administrar/certifirma-pkcs10',
  FISICO: '/administrar/certifirma-fisico',
  DESCARGAR_CERTIFICADO: '/administrar/descargar-certificado'
} as const;

/** Descripciones cortas para sidebar / menús */
export const CERTIFIRMA_DESC = {
  VIRTUAL: 'Autenticar y firmar con tu certificado en la nube',
  VIRTUAL_OTP: 'Firma con el código de seguridad enviado a tu correo',
  PKCS10: 'Archivo .p10/.pfx y contraseña',
  FISICO: 'Firma con la llave USB (requiere agente local)',
  VERIFY: 'Comprueba la validez de tus documentos firmados',
  ADMIN_VIRTUAL: 'Descargar / Recuperar clave',
  ADMIN_VIRTUAL_OTP: 'Descargar / Recuperar clave',
  ADMIN_PKCS10: 'Descargar certificado',
  ADMIN_FISICO: 'Consultar / Restablecer clave'
} as const;
